module.exports = ":host ::ng-deep .item-row .row-header h2 {\n  font-size: 3.5rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/related-row/related-row.styles.scss
// module id = 755
// module chunks = 2